import { DateFields, Services } from '@sigma-frontend-libs/commons'
import { EUrlShortenerSettingsPresetsAllowedScopes, OrderDirections } from '@sigmasms/shared-types'

import { isEmpty, serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: `${Services['url-shortener-settings/presets']}`,

      backendGeneration: 'nest',

      async inputFilter(result) {
        if (!('length' in result.generationParams)) {
          result.generationParams.length = undefined
        }
        if (!('pattern' in result.generationParams)) {
          result.generationParams.pattern = undefined
        }

        return result
      },

      async outputFilter(result) {
        for (const key of Object.keys(result.generationParams)) {
          if (isEmpty(result.generationParams[key])) {
            result.generationParams[key] = undefined
          }
        }
        if (!isEmpty(result.generationParams.length)) {
          result.generationParams.length = parseInt(result.generationParams.length)
        }

        return result
      },

      find: {
        defaultFilter: {
          order: [ [ DateFields.createdAt, OrderDirections.DESC ] ],
          scopes: [ EUrlShortenerSettingsPresetsAllowedScopes.full ],
          search: undefined,
          title: undefined,
          domainId: undefined,
          ownerId: undefined,
          createdAtPreset: undefined,
          createdAt: {
            gte: undefined,
            lt: undefined
          }
        }
      },
      get: {
        params: {
          query: {
            scopes: [ EUrlShortenerSettingsPresetsAllowedScopes.full ]
          }
        }
      },
      create: {
        params: {
          query: {
            scopes: [ EUrlShortenerSettingsPresetsAllowedScopes.full ]
          }
        }
      },

      has: {
        tabs: false,
        clone: false
      },

      formClass: '',
      titlePath: 'name'
    })
  ]
}
